// Buchhaltung — Offene Posten (Debitoren) mit Aging & Mahnwesen-Aktionen.
import { Loader2, Send, FileDown, Mail } from "lucide-react";
import { Button } from "../../components/ui/button";
import { formatPrice } from "../../lib/api";
import { fmtDate } from "./shared";

export default function OpenItemsTable({ data, busyId, onMahnen, onMahnenMail, onPdf }) {
    if (!data) return <div className="text-center py-12 text-gray-400"><Loader2 className="w-6 h-6 mx-auto animate-spin" /></div>;
    const items = data.items || [];
    if (items.length === 0) {
        return <div className="text-center py-12 text-gray-500 bg-white border border-gray-200 rounded-sm" data-testid="buchhaltung-op-empty">Keine offenen Posten — alles ausgeglichen. 🎉</div>;
    }
    return (
        <div className="bg-white border border-gray-200 rounded-sm overflow-auto" data-testid="buchhaltung-open-items">
            <table className="w-full text-[12px]">
                <thead className="bg-gray-100 text-gray-600">
                    <tr>
                        <th className="text-left px-3 py-2">Rechnung</th>
                        <th className="text-left px-3 py-2">Kunde</th>
                        <th className="text-left px-3 py-2">Fällig</th>
                        <th className="text-right px-3 py-2">Überfällig</th>
                        <th className="text-right px-3 py-2">Offen</th>
                        <th className="text-center px-3 py-2">Mahnstufe</th>
                        <th className="text-right px-3 py-2">Aktion</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((it) => (
                        <tr key={it.id} className="border-t border-gray-100 hover:bg-gray-50" data-testid={`buchhaltung-op-row-${it.id}`}>
                            <td className="px-3 py-2 font-mono-num font-bold text-[#111827]">{it.invoice_number || "—"}</td>
                            <td className="px-3 py-2 truncate max-w-[200px]">{it.customer_name}</td>
                            <td className="px-3 py-2">{fmtDate(it.due_date)}</td>
                            <td className={`px-3 py-2 text-right font-mono-num font-bold ${it.days_overdue > 60 ? "text-red-600" : it.days_overdue > 0 ? "text-amber-700" : "text-gray-500"}`}>
                                {it.days_overdue > 0 ? `${it.days_overdue} T` : "—"}
                            </td>
                            <td className="px-3 py-2 text-right font-mono-num font-bold">{formatPrice(it.open_amount)}</td>
                            <td className="px-3 py-2 text-center">
                                {it.reminder_level > 0
                                    ? <span className="inline-block text-[10px] font-bold px-1.5 py-0.5 rounded-sm bg-red-100 text-red-700">St. {it.reminder_level}</span>
                                    : <span className="text-gray-400">—</span>}
                            </td>
                            <td className="px-3 py-2">
                                <div className="flex items-center justify-end gap-1.5">
                                    {it.reminder_level > 0 && (
                                        <button type="button" onClick={() => onPdf(it.id, it.reminder_level)} className="text-[11px] font-bold text-[#111827] hover:underline inline-flex items-center gap-0.5" data-testid={`buchhaltung-op-pdf-${it.id}`}>
                                            <FileDown className="w-3.5 h-3.5" /> PDF
                                        </button>
                                    )}
                                    <Button type="button" onClick={() => onMahnen(it.id)} disabled={busyId === it.id || it.reminder_level >= 3}
                                        variant="outline" className="h-7 rounded-sm text-[11px] font-bold border-red-300 text-red-700 hover:bg-red-50 disabled:opacity-40"
                                        data-testid={`buchhaltung-op-mahnen-${it.id}`}>
                                        {busyId === it.id ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <><Send className="w-3.5 h-3.5 mr-1" /> Mahnen</>}
                                    </Button>
                                    <Button type="button" onClick={() => onMahnenMail(it)} disabled={busyId === it.id || it.reminder_level >= 3}
                                        variant="outline" className="h-7 rounded-sm text-[11px] font-bold border-[#111827] text-[#111827] hover:bg-gray-100 disabled:opacity-40"
                                        data-testid={`buchhaltung-op-mahnen-mail-${it.id}`}>
                                        <Mail className="w-3.5 h-3.5 mr-1" /> Per E-Mail
                                    </Button>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
